import concat from 'lodash/concat';
export const _concat = concat;
